module.exports = __webpack_public_path__ + "static/media/bball_stat_preview.97b18124.PNG";